import { VacationApprovalCard } from '@/features/Vacations/components/VacationApprovalCard';
import { KIND_LABELS } from '../../approvals.definitions';
import type { ApprovalDecisionKind, ApprovalItem } from '../../approvals.types';
import { DayOffApprovalCard } from './DayOffApprovalCard';

interface ApprovalCardProps {
    item: ApprovalItem;
    onDecide: (item: ApprovalItem, kind: ApprovalDecisionKind) => void;
    isActive?: boolean;
}

export function ApprovalCard({ item, onDecide, isActive = false }: ApprovalCardProps) {
    if (item.kind === 'day_off') {
        return <DayOffApprovalCard approval={item} onDecide={onDecide} isActive={isActive} />;
    }

    return (
        <VacationApprovalCard
            item={item.item}
            onDecide={(_vacationItem, kind) => onDecide(item, kind)}
            isActive={isActive}
            typeLabel={KIND_LABELS.vacation}
        />
    );
}
